export class DeviceConfigParams {
    constructor() {
        this.DeviceGuid = "";
    }
}
//# sourceMappingURL=DeviceConfigParams.js.map